




























import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'

@Component({
  components: {}
})
export default class CloneDialog extends Mixins(BaseVue) {
  @Prop({ default: false })
  public value!: boolean

  @Prop({ default: '' })
  public promotionName!: string
}
